export default __webpack_public_path__ + "static/media/alumini (7).71e2b789.jpg";